// extracted by mini-css-extract-plugin
export default {"wrap":"Checkbox_wrap__UtTpZ","cr":"Checkbox_cr__Devp7","disabled":"Checkbox_disabled__dlKPL","text":"Checkbox_text__kRXNv"};